'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerRecordResultsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerRecordResultsRemote = exports.SellerRecordResultsRemote = {
    fetchSellerRecordResultsById: function fetchSellerRecordResultsById(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            sellerId = _ref.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/seller/' + sellerId + '/recordResults', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/sellerRecordResults.js
// module id = I7qg
// module chunks = 46